(() => {
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-z-care]');
    if (trigger && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
      const dialog = document.getElementById(`z-care-${trigger.dataset.zCare}`);
      if (!dialog?.showModal) return;
      event.preventDefault();
      dialog.showModal();
      document.documentElement.classList.add('z-care-open');
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('z-care-open');
        trigger.focus();
      }, { once: true });
    }
    const close = event.target.closest('.z-care-close');
    if (close) close.closest('dialog').close();
    if (event.target.matches('.z-care-dialog')) {
      const box = event.target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
    }
    const copy = event.target.closest('[data-z-copy-offer]');
    if (copy) {
      const status = copy.parentElement.querySelector('[role="status"]');
      if (!navigator.clipboard?.writeText) {
        status.textContent = 'Enter 35OFF in the discount code field at checkout.';
        return;
      }
      navigator.clipboard.writeText('35OFF').then(() => {
        copy.textContent = 'Copied';
        status.textContent = 'Code copied. Use 35OFF at checkout.';
      }).catch(() => { status.textContent = 'Enter 35OFF in the discount code field at checkout.'; });
    }
  });

  // Enhance only this existing Klaviyo offer; leave its signup and consent flow intact.
  const enhanceOffer = () => {
    document.querySelectorAll('[data-testid="klaviyo-form-SGDCHW"]').forEach((form) => {
      form.querySelectorAll('.klaviyo-form-richtext').forEach((text) => {
        if (text.textContent.trim() === '35OFF') text.closest('[data-testid="form-row"]').classList.add('z-offer-original-code');
        text.querySelectorAll('strong').forEach((label) => {
          if (label.textContent.trim() === 'USE KOD BELOW AT CHECKOUT') label.textContent = 'YOUR FIRST ORDER, WITH 35% OFF';
        });
        text.querySelectorAll('h1').forEach((heading) => { heading.setAttribute('role', 'heading'); heading.setAttribute('aria-level', '2'); });
      });
      form.querySelectorAll('.klaviyo-form-button').forEach((button) => {
        button.classList.toggle('z-offer-dismiss', /^no,?\s*thanks!?$/i.test(button.textContent.trim()));
      });
      if (form.querySelector('.z-offer-code')) return;
      const action = form.querySelector('.klaviyo-form-button');
      const row = action?.closest('[data-testid="form-row"]');
      if (!row) return;
      const code = document.createElement('div');
      code.className = 'z-offer-code';
      code.innerHTML = '<p>Use this code at checkout</p><div><strong>35OFF</strong><button type="button" data-z-copy-offer>Copy code</button><span role="status" aria-live="polite"></span></div>';
      row.before(code);
    });
    document.querySelectorAll('[data-testid="animated-teaser"]').forEach((teaser) => {
      if (teaser.textContent.includes('35%')) teaser.classList.add('z-offer-teaser');
    });
  };
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; enhanceOffer(); });
  }).observe(document.body, { childList: true, subtree: true });
  enhanceOffer();
})();
